import React from "react";
import PropTypes from "prop-types";
import { Dialog } from "@mui/material";
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { useIntl } from "react-intl";

function ModalAtividadeIndisponivel({ open, onClose }) {
  const intl = useIntl();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{intl.formatMessage({ defaultMessage: "Atividade indisponível" })}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {intl.formatMessage({
            defaultMessage:
              "Esta atividade não está mais disponível e foi removida. Recarregue a página para acessar as informações atualizadas.",
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          {intl.formatMessage({ defaultMessage: "Fechar e recarregar" })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ModalAtividadeIndisponivel.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ModalAtividadeIndisponivel;
